export const incomeFields = [
  { name: "salary", label: "Salary" },
  { name: "overtime", label: "Overtime" },
  { name: "bonuses", label: "Bonuses" },
  { name: "publicAssistance", label: "Public Assistance" },
  { name: "spousalSupport", label: "Spousal Support" },
  { name: "partnerSupport", label: "Partner Support" },
  { name: "pension", label: "Pension" },
  { name: "socialSecurity", label: "Social Security" },
  { name: "unemployment", label: "Unemployment" },
  { name: "workersComp", label: "Workers' Compensation" },
  { name: "disability.ssi", label: "Disability (SSI)" },
  { name: "disability.state", label: "Disability (State)" },
  { name: "disability.private", label: "Disability (Private)" },
  { name: "otherIncome.source", label: "Other Income (Source)" },
  { name: "otherIncome.amount", label: "Other Income (Amount)" },
];
